<template>
  <div>
    <div v-if="loading" class="loading">
      <MoonLoader> </MoonLoader>
    </div>
    <!-- V-else -->
    <div v-else>
      <BackButton class="u-margin-bottom-small"> </BackButton>

      <div class="row">
        <div class="w-full">
          <h3>
            For Company <span class="text-primary"> {{ company.name }} </span>
          </h3>
        </div>
      </div>

      <div class="row">
        <div class="w-full">
          <edit-role-form :role="role" />
        </div>
      </div>

      <div class="row">
        <div class="w-full">
          <assigned-users-card :role="role" :company="company" />
        </div>
      </div>

      <div class="row">
        <div class="w-full">
          <assigned-scopes-card :scopes="role.scopes" :role="role" :company="company" />
        </div>
      </div>
    </div>
    <!-- End V-else Part -->
  </div>
</template>

<script>
import axiosAuth from '../../../axiosMain';
import BackButton from '../../../components/buttons/BackButton';
import MoonLoader from '../../../components/svg/SvgLoaderMoon';
import EditRoleForm from '../RightsManagement/EditRoleForm';
import AssignedUsersCard from '../RightsManagement/AssignedUsersCard';
import AssignedScopesCard from '../RightsManagement/AssignedScopesCard';

export default {
  name: 'SuperUserRightsManagementShow',
  components: {
    MoonLoader,
    BackButton,
    EditRoleForm,
    AssignedUsersCard,
    AssignedScopesCard,
  },
  data: function () {
    return {
      role: '',
      loading: true,
      company: null,
    };
  },
  async beforeMount() {
    this.setLoader();
    await this.setCompany();
    await this.getRole();
  },
  methods: {
    async getRole() {
      axiosAuth
        .post(
          '/company_roles/role/' + this.$route.params.id,
          {
            roles: [
              {
                role_id: this.$route.params.role_id,
              },
            ],
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.role = response.data.data;
          this.resetLoader();
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data,
          });
        });
    },
    setLoader: function () {
      this.loading = true;
    },
    resetLoader: function () {
      this.loading = false;
    },
    async setCompany() {
      try {
        let response = await axiosAuth.get('/companies/' + this.$route.params.id);
        this.company = response.data.data;
      } catch (e) {}
    },
  },
};
</script>

<style scoped></style>
